export const RESIZER_WIDTH = 8; // 2px line w/ 3px padding
export const SIDE_PANEL_DEFAULT_WIDTH = 450;
export const SIDE_PANEL_MIN_WIDTH = 450;
export const SIDE_PANEL_MENU_WIDTH = 70;
